import React, { useCallback } from 'react';
import DietitianSettingsForm from '../components/dietitian/DietitianSettingsForm';
import { dietitianStrings } from '../components/dietitian/strings';
import { pageTitle } from '../components/dietitian/ui';
import { useCurrentUser } from '../hooks/useCurrentUser';
import { makeT, useLanguage } from '../hooks/useLanguage';
import { DietitianSettings } from '../services/dietitianApi';

const strings = {
  english: {
    ...dietitianStrings.english,
    'page.title': 'My link',
    'page.subtitle': 'Share your code or link. Clients who join through it become your clients, with your plan and questions.',
  },
  hebrew: {
    ...dietitianStrings.hebrew,
    'page.title': 'הקישור שלי',
    'page.subtitle': 'שתפו את הקוד או הקישור. לקוחות שמצטרפים דרכו הופכים ללקוחות שלך, עם המסלול והשאלות שלך.',
  },
};

export default function MyLinkPage() {
  const { language, direction } = useLanguage();
  const t = makeT(strings, language);
  const { currentUser } = useCurrentUser();
  const canUpload = currentUser?.role === 'company_manager' || currentUser?.role === 'sys_admin';

  const load = useCallback(() => DietitianSettings.getMine(), []);
  const save = useCallback((patch) => DietitianSettings.saveMine(patch), []);

  return (
    <div className="min-h-screen bg-canvas pb-16" dir={direction}>
      <main className="mx-auto max-w-7xl px-4 sm:px-6 py-8">
        <header className="mb-8">
          <h1 className={pageTitle}>{t('page.title')}</h1>
          <p className="mt-2 max-w-2xl text-[13px] text-ink-muted">{t('page.subtitle')}</p>
        </header>
        <DietitianSettingsForm
          load={load}
          save={save}
          t={t}
          language={language}
          companyName={currentUser?.company_name || ''}
          canUpload={canUpload}
          idPrefix="mylink"
        />
      </main>
    </div>
  );
}
